module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADSSURBVHgB7ZaxDcIwEEXPxANkBDMKi0AVt7ABYQPSJlW8CKPgERgg1mEiIdnG8YkqQtyTUvjnJXZh3R3AvyMoYd9PmETWaLnNu+4OgCrMvFvcYwMrwweQtCJsuEJAu2S+3gn6WjEME0GX4sGdowDhYXTVZd3eHf0f6zAzTXWBAnQdQGyTxPqnW7BP3ldJVjwAl+If6AVCtNHaX8KCffV+DQzDfAHZCw7zqB1+gXZs5C7rDtMNUKgwG3WVHeHfkHUAkzkfsODOm3/0giJcilc/APMEOU02MbIfelIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/test/drag_icon.png
// module id = Gq19
// module chunks = 4